import { render, staticRenderFns } from "./wsEntityDialog.vue?vue&type=template&id=1358ffab&scoped=true&"
import script from "./wsEntityDialog.vue?vue&type=script&lang=js&"
export * from "./wsEntityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1358ffab",
  null
  
)

export default component.exports